<template>
    <div class="StatisticsMarketing">
        <v-container fluid class="pa-6">
            <v-select :items="filteredTabOptions" v-model="tabModel" @change="key++" solo style="display: inline-block;"></v-select>

            <StatisticsMarketingLead v-show="tabModel == 0" :loadData="tabModel == 0 ? true : false" />
            <StatisticsMarketingDatabase v-show="tabModel == 1" :loadData="tabModel == 1 ? true : false" />
            <StatisticsMarketingDelivrability v-show="tabModel == 2 && packId != 4" :loadData="tabModel == 2 && packId != 4 ? true : false" />
        </v-container>
    </div>
</template>

<script>
import StatisticsMarketingLead from '../components/StatisticsMarketingLead.vue'
import StatisticsMarketingDatabase from '../components/StatisticsMarketingDatabase.vue'
import StatisticsMarketingDelivrability from '../components/StatisticsMarketingDelivrability.vue'

export default {
    name: "StatisticsMarketing",
    components: {
        StatisticsMarketingLead,
        StatisticsMarketingDatabase,
        StatisticsMarketingDelivrability,
    },
    data() {
        return {
            key:0,
            tabModel: 0,
            tabOptions: [
                { text: this.$t('lead_source'), tabValue: 'lead_source', value: 0 },
                { text: this.$t('database_health'), tabValue: 'database_health', value: 1 },
                { text: this.$t('email_delivrability'), tabValue: 'email_delivrability', value: 2 }
            ],
        }
    },
    destroyed() {
        
    },
    computed: {
        packId(){
            if(this.$store.state.auth.currentUser && this.$store.state.auth.currentUser.accountParameters && this.$store.state.auth.currentUser.accountParameters.packId)
                return this.$store.state.auth.currentUser.accountParameters.packId
            else 
                return false
        },
        filteredTabOptions() {
            if (this.packId == 4) {
                return this.tabOptions.filter(tab => tab.tabValue !== 'email_delivrability');
            }
            return this.tabOptions;
        }
    },
    methods: {

    },
    watch: {
        tabModel: {
            handler(newVal) {
                this.$router.replace({ query: { tab: this.tabOptions.find(tab => tab.value == newVal).tabValue } }).catch(err => { });
            },
            deep: true,
        }
    },
    created() {
        if(this.$route.query.tab) {
            this.tabModel = this.tabOptions.find(tab => tab.tabValue == this.$route.query.tab).value;
        } else {
            console.log(this.$route.query)
            
            let params = [];
            for (const key in this.$route.query) {
                if (Object.prototype.hasOwnProperty.call(this.$route.query, key)) {
                    params[key] = this.$route.query[key];
                }
            }
            params['tab'] = this.tabOptions[0].tabValue;
            this.$router.replace({ query: params }).catch(err => { });
            history.replaceState({}, null, this.$route.path + '?' + Object.keys(params)
                .map(key => { return (encodeURIComponent(key) + '=' + encodeURIComponent(params[key])); })
                .join('&'));
        }
    },
}
</script>

<style lang="scss">
    .StatisticsMarketing {
        // Styles spécifiques au composant StatisticsMarketing
    }
</style>